// Wave 20.49at — Alerts bell for the header.
//
// Polls GET /alerts/unread-count every 60 s. Renders as an
// IconButton with a Badge showing the unread count; clicking
// navigates to /alerts.
//
// Silent on failure — a red badge on a network glitch is worse
// than a missing badge for a beat.

import React, { useEffect, useState } from 'react';
import { Badge, IconButton } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { Link as RouterLink } from 'react-router-dom';
import { colors } from '../theme';

const API = process.env.REACT_APP_API || 'https://api.aero.chat';
const TOKEN_KEY = process.env.REACT_APP_TOKEN_KEY || 'aero.chat_token';

export default function AlertsBell() {
  const [count, setCount] = useState(0);
  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const jwt = localStorage.getItem(TOKEN_KEY);
        if (!jwt) return;
        const res = await fetch(`${API}/alerts/unread-count`, {
          headers: { Authorization: `Bearer ${jwt}` },
        });
        if (!res.ok) return;
        const j = (await res.json()) as { count: number };
        if (!cancelled && typeof j.count === 'number') setCount(j.count);
      } catch { /* silent — the badge just doesn't show */ }
    };
    load();
    const id = setInterval(load, 60_000);
    const onFocus = () => load();
    window.addEventListener('focus', onFocus);
    return () => {
      cancelled = true;
      clearInterval(id);
      window.removeEventListener('focus', onFocus);
    };
  }, []);
  return (
    <IconButton
      component={RouterLink}
      to="/alerts"
      aria-label={`Alerts${count > 0 ? ` (${count} unread)` : ''}`}
      sx={{
        color: colors.textMuted,
        border: `1px solid ${colors.border}`,
        width: 40,
        height: 40,
        '&:hover': { borderColor: colors.brand, color: colors.brand },
      }}
    >
      <Badge
        badgeContent={count}
        color="error"
        overlap="circular"
        max={99}
      >
        <NotificationsIcon fontSize="small" />
      </Badge>
    </IconButton>
  );
}
